import { Component, OnInit } from '@angular/core';
import { WorldService } from './world.service';

@Component({
    selector: 'app-word-controller',
    templateUrl: './word-controller.component.html',
    styleUrls: ['./word-controller.component.css']
})
export class WordControllerComponent implements OnInit {

    constructor(private worldService: WorldService) {
    }

    ngOnInit(): void {
    }

    onSpawnNpc(): void {
        this.worldService.spawnNpc();
    }

    onSpawnCop(): void {
        this.worldService.spawnCop();
    }

}
